import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';

export const RENEWAL_PROMOTION_SCHEMA = Object.freeze({
  DISCOUNT_PERCENTAGE: 0,
  HEADER: '',
  BODY: '',
  CTA: '',
});
const RECORD = generateSchema(RENEWAL_PROMOTION_SCHEMA);
const KEYS: any = generateKeys(RENEWAL_PROMOTION_SCHEMA);

export class RenewalPromotion extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get discountPercentage(): number {
    return this.get(KEYS.DISCOUNT_PERCENTAGE);
  }

  get header(): string {
    return this.get(KEYS.HEADER);
  }

  get body(): string {
    return this.get(KEYS.BODY);
  }

  /**
   * Button CTA
   */
  get cta(): string {
    return this.get(KEYS.CTA);
  }
}
